import GenerateStatusProgress from "./generateStatusProgress.container";

export default GenerateStatusProgress;
